import React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";

const ModalDetaliiPartida = ({ show, onHide, partidaSelectata }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="modal-modern-compact"
    >
      <Modal.Header closeButton className="border-0 pb-1 pt-3 px-3">
        <Modal.Title className="fw-bold text-success fs-5 d-flex align-items-center gap-2">
          <span>🌲</span> Detalii partidă:{" "}
          <span className="fw-bold text-success fs-5 d-flex align-items-center gap-2">
            {partidaSelectata?.fond} / {partidaSelectata?.sumal}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-3 pt-2">
        {partidaSelectata ? (
          <Row className="g-2">
            {/* Secțiunea 1 - Date identificare */}
            <Col xs={12}>
              <div
                className="text-secondary text-uppercase fw-bold small mb-1 border-bottom pb-1"
                style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}
              >
                📍 Date de identificare
              </div>
            </Col>

            <Col md={4} sm={4} xs={6}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Ocol Silvic</div>
                <div className="fw-semibold text-dark compact-val">
                  {partidaSelectata?.ocol || "-"}
                </div>
              </div>
            </Col>

            <Col md={4} sm={4} xs={6}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">
                  Unitate Producție (UP)
                </div>
                <div className="fw-semibold text-dark compact-val ">
                  {partidaSelectata?.up || "-"}
                </div>
              </div>
            </Col>

            <Col md={4} sm={4} xs={12}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">
                  Unitate Amenajistică (UA)
                </div>
                <div className="fw-semibold text-dark compact-val ">
                  {partidaSelectata?.ua || "-"}
                </div>
              </div>
            </Col>
            <Col md={4} sm={4} xs={12}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Natură Produs</div>
                <div className="fw-semibold text-dark compact-val">
                  {partidaSelectata?.natura || "-"}
                </div>
              </div>
            </Col>

            <Col md={4} sm={4} xs={12}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Natura Tăierii</div>
                <div className="fw-semibold text-dark compact-val">
                  {partidaSelectata?.taiere || "-"}
                </div>
              </div>
            </Col>

            <Col md={4} sm={4} xs={12}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Stoc</div>
                <div className="fw-semibold text-dark compact-val">
                  {partidaSelectata?.stoc || "0"}
                </div>
              </div>
            </Col>

            {/* Secțiunea 2 - Volum*/}
            <Col xs={12} className="mt-2">
              <div
                className="text-secondary text-uppercase fw-bold small mb-1 border-bottom pb-1"
                style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}
              >
                📊 Suprafață și Volum
              </div>
            </Col>

            <Col md={4} sm={4} xs={6}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Suprafață</div>
                <div className="fw-semibold text-dark compact-val">
                  {partidaSelectata?.suprafata}{" "}
                  <span className="small text-muted fw-normal">ha</span>
                </div>
              </div>
            </Col>

            <Col md={4} sm={4} xs={6}>
              <div className="bg-light p-2 rounded-2 border border-opacity-10">
                <div className="text-muted compact-label">Volum Brut</div>
                <div className="fw-bold compact-val">
                  {partidaSelectata?.volBrut}{" "}
                  <span className="small fw-normal">mc</span>
                </div>
              </div>
            </Col>

            {/* Secțiunea 3 - Date financiare */}
            <Col xs={12} className="mt-2">
              <div
                className="text-secondary text-uppercase fw-bold small mb-1 border-bottom pb-1"
                style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}
              >
                💼 Aspecte Financiare
              </div>
            </Col>

            <Col sm={6} xs={12}>
              <div className="bg-success bg-opacity-10 p-2 rounded-2 border border-success border-opacity-25">
                <div
                  className="text-success small fw-bold"
                  style={{ fontSize: "0.7rem" }}
                >
                  Valoare Totală
                </div>
                <div className="fw-bold text-success fs-5">
                  {parseFloat(partidaSelectata?.valTotal || 0).toLocaleString(
                    "ro-RO",
                  )}{" "}
                  <span className="fs-6 fw-normal">RON</span>
                </div>
              </div>
            </Col>

            <Col sm={6} xs={12}>
              <div className="bg-warning bg-opacity-10 p-2 rounded-2 border border-warning border-opacity-25">
                <div
                  className="text-warning-dark small fw-bold"
                  style={{ fontSize: "0.7rem" }}
                >
                  Garanție
                </div>
                <div className="fw-bold text-warning-dark fs-5">
                  {parseFloat(partidaSelectata?.garantie || 0).toLocaleString(
                    "ro-RO",
                  )}{" "}
                  <span className="fs-6 fw-normal">RON</span>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <div className="text-center py-4">
            <div
              className="spinner-border spinner-border-sm text-success mb-2"
              role="status"
            ></div>
            <p className="text-muted small mb-0">Se încarcă datele...</p>
          </div>
        )}
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer className="border-0 pt-0 pb-3 px-3">
        <Button
          variant="outline-secondary"
          onClick={onHide}
          className="px-3 py-1 rounded-2 btn-sm fw-semibold"
        >
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetaliiPartida;